import { type ResultOf } from '@graphql-typed-document-node/core'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

const document = graphql(`
  mutation CustomerAttributeListPAge_DeleteCustomerAttribute(
    $customerAttributeId: ID!
  ) {
    deleteCustomerAttribute(id: $customerAttributeId) {
      result
    }
  }
`)

export const useDeleteCustomerAttributeMutation = (
  options: Omit<
    UseMutationOptions<ResultOf<typeof document>, unknown, string, unknown>,
    'mutationFn'
  > = {},
) => {
  const graphQLRequest = useGraphQLRequest()

  return useMutation({
    mutationFn: (customerAttributeId) =>
      graphQLRequest({ document, variables: { customerAttributeId } }),
    ...options,
  })
}
